/* Guarded: a throw here used to abort the rest of custom.js (plan guard included). */
function mobileOnlySlider($slidername, $dots, $arrows, $slidesToShow, $autoplay, $breakpoint) {
  if (typeof window.jQuery === 'undefined' || !$.fn || !$.fn.slick) { return; }
  var slider = $($slidername);
  if (!slider.length) { return; }
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    slidesToShow:$slidesToShow,
    autoplay: $autoplay,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick"
      }
    ]
  };

  try { slider.slick(settings); } catch (e) {}
  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      try { return slider.slick(settings); } catch (e) {}
    }
  });
}
try { mobileOnlySlider(".logo-bar", false, false, 3, true, 767); } catch (e) {}

/* ============================================================
   Bundle line flag [Kopstorm, 6 Sep 2026]
   The bundle builder used to write one line property,
   '_bundle_page'. Stay AI asked the new bundle page to write
   '_bundle_page_2' instead so the new and old bundle
   experiences can be told apart on the subscription. Both names
   are accepted here so the guard keeps working before, during
   and after the switch, and on carts that mix lines added from
   the old and the new page.
   ============================================================ */
window.KOP_BUNDLE_LINE_ATTRS = ['_bundle_page', '_bundle_page_2'];
function kopIsBundleLine(props) {
  if (!props) { return false; }
  var names = window.KOP_BUNDLE_LINE_ATTRS;
  for (var i = 0; i < names.length; i++) {
    if (props[names[i]] === 'true') { return true; }
  }
  return false;
}

/* ============================================================
   Rho bundle free gift — UpCart drawer display [Kopstorm]
   The blender-bottle gift is zeroed by a Shopify Discount
   Function at CHECKOUT only; UpCart renders the raw variant
   price in the drawer. This patch strikes that price and shows
   a FREE badge on the gift line while the cart qualifies
   (8+ bundle subscription units, either line flag). Best-effort
   it locates the gift line inside the drawer via its product
   URL, so it survives UpCart class-name changes. Checkout
   always shows the true $0 from the Function.
   ============================================================ */
(function () {
  var GIFT_MIN = 8;               // mirrors tier2_qty in the bundle section + Function
  var MONEY_RE = /(\$|€|£)\s?\d/;
  var state = { handle: null, qualified: false, timer: null };

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) { return; }
        var qty = 0, gift = null;
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._bundle_gift === 'true') { gift = it; return; }
          if (kopIsBundleLine(p) && it.selling_plan_allocation) { qty += it.quantity; }
        });
        state.handle = gift ? gift.handle : null;
        state.qualified = !!gift && qty >= GIFT_MIN;
        paint();
      })
      .catch(function () {});
  }

  function lineContainer(anchor) {
    /* Walk up from the product link to the drawer line-item wrapper. */
    var el = anchor, i = 0;
    while (el && el !== document.body && i < 6) {
      var cls = (el.className || '') + '';
      if (el.tagName === 'LI' || /item|product|line/i.test(cls)) { return el; }
      el = el.parentElement; i++;
    }
    return anchor.parentElement;
  }

  function priceNodes(container) {
    var out = [];
    var walker = container.querySelectorAll('*');
    for (var i = 0; i < walker.length; i++) {
      var n = walker[i];
      if (n.children.length) { continue; }
      if (n.closest('[data-rho-gift-free]')) { continue; }
      var txt = (n.textContent || '').trim();
      if (txt.length && txt.length < 16 && MONEY_RE.test(txt)) { out.push(n); }
    }
    return out;
  }

  function paint() {
    var marked = document.querySelectorAll('[data-rho-gift-line]');
    if (!state.handle || !state.qualified) {
      /* Disqualified (items removed below 8): restore normal display. */
      Array.prototype.forEach.call(marked, function (el) {
        el.removeAttribute('data-rho-gift-line');
        Array.prototype.forEach.call(el.querySelectorAll('[data-rho-gift-struck]'), function (p) {
          p.style.textDecoration = ''; p.style.opacity = '';
          p.removeAttribute('data-rho-gift-struck');
        });
        Array.prototype.forEach.call(el.querySelectorAll('[data-rho-gift-free]'), function (b) { b.remove(); });
      });
      return;
    }
    var anchors = document.querySelectorAll('a[href*="/products/' + state.handle + '"]');
    Array.prototype.forEach.call(anchors, function (a) {
      /* Only touch links inside a cart drawer, never the main page content. */
      var drawer = a.closest('[class*="upcart" i], [id*="upcart" i], [class*="cart-drawer" i], [id*="CartDrawer" i]');
      if (!drawer) { return; }
      var box = lineContainer(a);
      if (!box || box.hasAttribute('data-rho-gift-line')) { return; }
      box.setAttribute('data-rho-gift-line', '');
      var prices = priceNodes(box);
      prices.forEach(function (p) {
        p.style.textDecoration = 'line-through';
        p.style.opacity = '.55';
        p.setAttribute('data-rho-gift-struck', '');
      });
      if (prices.length) {
        var badge = document.createElement('span');
        badge.setAttribute('data-rho-gift-free', '');
        badge.textContent = 'FREE';
        badge.style.cssText = 'margin-left:6px;font-weight:700;color:#0d0047;letter-spacing:.03em;';
        prices[0].parentElement.appendChild(badge);
      }
    });
  }

  function schedule() {
    clearTimeout(state.timer);
    state.timer = setTimeout(refresh, 250);
  }

  /* Re-check whenever the cart mutates or the drawer re-renders. */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(schedule, function () {}); }
    return p;
  };
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest('[class*="upcart" i], [id*="upcart" i], [class*="cart-drawer" i], [id*="CartDrawer" i]')) {
        clearTimeout(state.timer);
        state.timer = setTimeout(paint, 150);
        return;
      }
    }
  });
  if (document.body) { mo.observe(document.body, { childList: true, subtree: true }); }
  else { document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); }); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refresh); }
  else { refresh(); }
})();

/* ============================================================
   Rho bundle tier plan guard [Kopstorm] — 15 Jul 2026
   The two Stay "Bundle & Save" selling plans (20% / 30%) must
   only ever be reachable through the bundle page. UpCart's
   line-item subscription switcher (and any other plan <select>
   on the storefront) exposes every plan on the product, which
   let customers hand-pick the 30% plan with 2 items in cart.
   This guard does three things, storewide:

   1. SELECTOR FILTERING — OS-native <select> menus (Mac Chrome +
      iOS Safari) ignore option{display:none}, and UpCart/React
      re-inserts options after async deletes. We DELETE the two
      bundle <option>s in-place, synchronously on pointerdown via
      composedPath() (Shadow-DOM safe), and re-strip on UpCart's
      upcartOnCartUpdated/Loaded hooks plus shadow-root observers.
   2. SELECTOR LOCK on bundle lines — a line already ON a bundle
      plan gets its switcher hidden and replaced with a static
      plan label, so it can't be switched off (or gamed up) in
      the drawer.
   3. TIER ENFORCEMENT — after every cart mutation the guard
      recounts the bundle subscription units (either line flag)
      and rewrites
      each bundle line's selling plan via /cart/change.js:
        8+ units -> 30% plan, 4-7 -> 20% plan.
      Below 4 units the bundle promise is void: lines fall back
      to the product's base Subscribe & Save plan when it can be
      read from the line's own (hidden) selector options,
      otherwise to a one-time purchase, so nobody keeps bundle
      pricing without meeting the tier. The tier-2 gift line is
      removed when the cart drops below 8 qualifying units.

   Plan ids and tier thresholds mirror the bundle section
   settings on page.about (Sean/Stay, 13 Jul 2026). If the plan
   groups are ever recreated, update BUNDLE_PLANS here AND the
   section settings.
   ============================================================ */
(function () {
  var PLAN_T1 = 6210912506;              // Bundle & Save 20% (legacy at switchover)
  var PLAN_T2 = 6210945274;              // Bundle & Save 30% (legacy at switchover)
  var PLAN_NEW = 8460271866;             // new single group (Sean/Stay, 20 Aug 2026) - 0% at switchover
  var BUNDLE_PLANS = [String(PLAN_T1), String(PLAN_T2), String(PLAN_NEW)];
  var TIER1 = 4, TIER2 = 8;              // mirror tier1_qty / tier2_qty
  /* Discount code mode (Stay switchover): bundle lines sit on PLAN_NEW at 0%
     and the tier discount is a code. Detected from the cart itself (a bundle
     line on PLAN_NEW), so this file needs no flag: legacy carts keep the
     plan rewrite, code-mode carts keep the plan and get the code reconciled.
     Mirror tier1_code / tier2_code in the bundle section settings. */
  var CODE_T1 = 'BUNDLE20', CODE_T2 = 'BUNDLE30';
  var BUNDLE_CODES = [CODE_T1, CODE_T2];

  /* Apps rarely put the bare selling plan id in option values — UpCart et al.
     use formats like "gid://shopify/SellingPlan/6210912506" or composite keys,
     or stash the id in a data attribute. The ids are long enough that a
     substring match cannot false-positive. */
  function containsBundlePlan(str){
    str = String(str || '');
    for (var i = 0; i < BUNDLE_PLANS.length; i++) {
      if (str.indexOf(BUNDLE_PLANS[i]) !== -1) { return true; }
    }
    return false;
  }
  function isBundlePlan(v){ return containsBundlePlan(v); }
  function optionIsBundlePlan(opt){
    if (!opt) { return false; }
    if (containsBundlePlan(opt.value) || containsBundlePlan(opt.getAttribute && opt.getAttribute('value'))) { return true; }
    var attrs = opt.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      if (containsBundlePlan(attrs[i].value)) { return true; }
    }
    return false;
  }
  function selectOnBundlePlan(sel){
    var cur = sel.options[sel.selectedIndex];
    if (cur && optionIsBundlePlan(cur)) { return true; }
    return containsBundlePlan(sel.value);
  }

  /* ---------- 1 + 2: sanitize every selling-plan <select> ----------
     UpCart may render in open Shadow DOM. Page CSS / body MutationObservers
     do not see inside shadows, and OS-native <select> menus (Mac Chrome +
     iOS Safari) ignore option{display:none}. Strategy:
       - pierce every open shadow root
       - DELETE the bundle <option>s in-place (select.remove)
       - do that synchronously on pointerdown via composedPath() so the
         native picker snapshots a clean list
       - re-strip when React puts options back (observer + UpCart hooks) */
  var DRAWER_SEL = [
    '[class*="upcart"]', '[id*="upcart"]',
    '[class*="UpCart"]', '[id*="UpCart"]',
    '[class*="cart-drawer"]', '[id*="CartDrawer"]', '[id*="cart-drawer"]'
  ].join(',');
  var observedRoots = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var injectedRoots = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var HIDE_CSS = 'select[data-rho-plan-locked]{display:none!important;pointer-events:none!important;}' +
    'option[data-rho-bundle-plan="1"]{display:none!important;}';

  function qsaSafe(root, sel){
    try { return root.querySelectorAll(sel); }
    catch (e) { return []; }
  }

  function injectCss(root){
    if (!root) { return; }
    if (injectedRoots) {
      if (injectedRoots.has(root)) { return; }
      injectedRoots.add(root);
    } else if (root.__rhoPlanCss) { return; }
    else { root.__rhoPlanCss = true; }
    try {
      var style = document.createElement('style');
      style.setAttribute('data-rho-plan-css', '');
      style.textContent = HIDE_CSS;
      var host = root.head || root;
      host.appendChild(style);
    } catch (e) {}
  }

  function walkShadowSelects(root, out){
    if (!root) { return; }
    injectCss(root);
    var selects = qsaSafe(root, 'select');
    for (var i = 0; i < selects.length; i++) { out.push(selects[i]); }
    var all = qsaSafe(root, '*');
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) { walkShadowSelects(all[j].shadowRoot, out); }
    }
  }

  function collectSelects(){
    var out = [];
    walkShadowSelects(document, out);
    return out;
  }

  function selectHasBundleOptions(sel){
    for (var i = 0; i < sel.options.length; i++) {
      if (optionIsBundlePlan(sel.options[i])) { return true; }
    }
    return false;
  }

  function firstSafeIndex(sel){
    for (var i = 0; i < sel.options.length; i++) {
      if (!optionIsBundlePlan(sel.options[i])) { return i; }
    }
    return -1;
  }

  /* Synchronous, in-place deletion — the only thing native pickers honour. */
  function stripBundleOptions(sel){
    var selectedWasBundle = selectOnBundlePlan(sel);
    for (var i = sel.options.length - 1; i >= 0; i--) {
      var opt = sel.options[i];
      if (optionIsBundlePlan(opt)) {
        try { opt.setAttribute('data-rho-bundle-plan', '1'); } catch (e) {}
        try { sel.remove(i); } catch (err) {
          try { opt.parentNode.removeChild(opt); } catch (err2) {}
        }
      }
    }
    var groups = sel.querySelectorAll('optgroup');
    for (var g = groups.length - 1; g >= 0; g--) {
      if (!groups[g].querySelector('option') && groups[g].parentNode) {
        groups[g].parentNode.removeChild(groups[g]);
      }
    }
    if (selectedWasBundle) {
      var idx = firstSafeIndex(sel);
      if (idx >= 0) { sel.selectedIndex = idx; }
    }
  }

  function blockSelectOpen(e){
    try { e.preventDefault(); e.stopImmediatePropagation(); } catch (err) {
      try { e.preventDefault(); e.stopPropagation(); } catch (err2) {}
    }
  }

  function hideSelect(sel){
    sel.setAttribute('data-rho-plan-locked', '');
    try { sel.style.setProperty('display', 'none', 'important'); } catch (e) { sel.style.display = 'none'; }
    try { sel.style.setProperty('pointer-events', 'none', 'important'); } catch (e2) {}
    try { sel.style.setProperty('position', 'absolute', 'important'); } catch (e3) {}
    try { sel.style.setProperty('opacity', '0', 'important'); } catch (e4) {}
    try { sel.style.setProperty('width', '0', 'important'); } catch (e5) {}
    try { sel.style.setProperty('height', '0', 'important'); } catch (e6) {}
    sel.setAttribute('aria-hidden', 'true');
    sel.tabIndex = -1;
    if (!sel.__rhoPlanBlocked) {
      sel.__rhoPlanBlocked = true;
      sel.addEventListener('mousedown', blockSelectOpen, true);
      sel.addEventListener('pointerdown', blockSelectOpen, true);
      sel.addEventListener('touchstart', blockSelectOpen, true);
      sel.addEventListener('focus', blockSelectOpen, true);
      sel.addEventListener('click', blockSelectOpen, true);
      sel.addEventListener('keydown', blockSelectOpen, true);
    }
  }

  function lockSelect(sel){
    hideSelect(sel);
    /* Also drop the OTHER bundle plan from the list so a failed hide cannot
       expose a second tier to pick. Keep the currently-selected option. */
    var currentVal = String(sel.value || '');
    for (var i = sel.options.length - 1; i >= 0; i--) {
      var opt = sel.options[i];
      if (optionIsBundlePlan(opt) && String(opt.value) !== currentVal && currentVal.indexOf(String(opt.value)) === -1) {
        try { sel.remove(i); } catch (e) {
          try { opt.parentNode.removeChild(opt); } catch (e2) {}
        }
      }
    }
    if (!sel.parentNode) { return; }
    if (sel.parentNode.querySelector('[data-rho-plan-label]')) { return; }
    var current = sel.options[sel.selectedIndex];
    var label = document.createElement('span');
    label.setAttribute('data-rho-plan-label', '');
    label.textContent = current ? current.textContent.trim() : 'Bundle & Save subscription';
    label.style.cssText = 'display:block;font-size:12px;opacity:.75;padding:2px 0;';
    sel.parentNode.insertBefore(label, sel.nextSibling);
  }

  var sanitizing = false;
  function sanitizeSelectors(){
    if (sanitizing) { return; }
    sanitizing = true;
    try {
      var selects = collectSelects();
      for (var i = 0; i < selects.length; i++) {
        var sel = selects[i];
        var onBundle = selectOnBundlePlan(sel);
        if (!selectHasBundleOptions(sel) && !sel.hasAttribute('data-rho-plan-locked') && !onBundle) { continue; }

        if (onBundle || sel.hasAttribute('data-rho-plan-locked')) {
          /* Bundle line: hide the control. Do NOT strip options while the
             selected value is a bundle plan — changing selectedIndex can make
             UpCart write a non-bundle plan back to the cart. */
          lockSelect(sel);
          continue;
        }
        stripBundleOptions(sel);
      }
      watchNewShadows();
    } finally {
      sanitizing = false;
    }
  }

  function selectFromEvent(e){
    var path = [];
    try { path = e.composedPath ? e.composedPath() : []; } catch (err) { path = []; }
    if (!path.length && e.target) { path = [e.target]; }
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.tagName === 'SELECT') { return n; }
    }
    var t = e.target;
    if (t && t.closest) {
      try { return t.closest('select'); } catch (err2) { return null; }
    }
    return null;
  }

  function eventInDrawer(e){
    var path = [];
    try { path = e.composedPath ? e.composedPath() : [e.target]; } catch (err) { path = [e.target]; }
    for (var i = 0; i < path.length; i++) {
      if (inDrawerNode(path[i]) || (path[i] && path[i].host && inDrawerNode(path[i].host))) { return true; }
    }
    return false;
  }

  /* Must run sync on the capture path BEFORE the OS picker snapshots options. */
  function preOpenSanitize(e){
    var sel = selectFromEvent(e);
    if (sel) {
      if (selectOnBundlePlan(sel) || sel.hasAttribute('data-rho-plan-locked')) {
        lockSelect(sel);
        try { e.preventDefault(); e.stopPropagation(); } catch (err) {}
        return;
      }
      if (selectHasBundleOptions(sel)) { stripBundleOptions(sel); }
      return;
    }
    if (eventInDrawer(e)) {
      stripAllUpcartDropdowns();
      sanitizeSelectors();
    }
  }

  /* ---------- 3: tier enforcement ---------- */
  var enforcing = false;
  var enforceTimer = null;

  function bundleQty(cart){
    var qty = 0;
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._bundle_gift === 'true') { return; }
      if (kopIsBundleLine(p) && it.selling_plan_allocation) { qty += it.quantity; }
    });
    return qty;
  }
  function cartInCodeMode(cart){
    return (cart.items || []).some(function (it) {
      var p = it.properties || {};
      return kopIsBundleLine(p) && p._bundle_gift !== 'true' && it.selling_plan_allocation &&
        String(it.selling_plan_allocation.selling_plan.id) === String(PLAN_NEW);
    });
  }
  /* true when the cart used to hold code-mode lines but none qualify any more
     (everything dropped below tier 1 and fell back to base plans): the bundle
     code must then come off as well. */
  function cartHasBundleCode(cart){
    return (cart.discount_codes || []).some(function (d) {
      return BUNDLE_CODES.indexOf(String(d.code || '').toUpperCase()) !== -1;
    });
  }
  /* Keep the cart's discount codes in step with the qualifying quantity:
     8+ -> BUNDLE30, 4-7 -> BUNDLE20, below 4 -> no bundle code. Codes that are
     not ours (campaign codes) are preserved. Resolves true when it changed
     something. */
  function reconcileCode(cart, qty){
    var want = qty >= TIER2 ? CODE_T2 : (qty >= TIER1 ? CODE_T1 : null);
    var have = (cart.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); });
    var others = have.filter(function (c) { return BUNDLE_CODES.indexOf(c) === -1; });
    var mine = have.filter(function (c) { return BUNDLE_CODES.indexOf(c) !== -1; });
    var ok = want ? (mine.length === 1 && mine[0] === want) : mine.length === 0;
    if (ok && Array.isArray(cart.discount_codes)) { return Promise.resolve(false); }
    var next = others.slice();
    if (want) { next.push(want); }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: next.join(',') })
    }).then(function () {
      /* cookie fallback only when a code should be present; below tier 1
         the cart-side removal is what checkout reads (the validation Function
         is the backstop if a stale cookie still carries a code) */
      if (want) { return fetch('/discount/' + encodeURIComponent(want), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {}); }
    }).then(function () { return true; }, function () { return false; });
  }

  /* Base-plan fallback for a line that dropped below tier 1: read the first
     non-bundle subscription option from the line's own switcher in the drawer.
     Returns a numeric plan id, or null for "no plan found" (-> one-time). */
  function basePlanFor(item){
    var anchors = document.querySelectorAll('a[href*="/products/' + item.handle + '"]');
    for (var a = 0; a < anchors.length; a++) {
      var box = anchors[a], depth = 0;
      while (box && depth < 7) {
        var sel = box.querySelector && box.querySelector('select[data-rho-plan-locked], select');
        if (sel) {
          var opts = sel.querySelectorAll('option');
          for (var i = 0; i < opts.length; i++) {
            var v = (opts[i].value || '').trim();
            if (/^\d+$/.test(v) && !isBundlePlan(v)) { return parseInt(v, 10); }
          }
          break;
        }
        box = box.parentElement; depth++;
      }
    }
    return null;
  }

  function changeLine(key, quantity, sellingPlan){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity, selling_plan: sellingPlan })
    });
  }

  /* After the guard rewrites plans behind the app's back, nudge the drawer to
     re-render so prices/labels update without a page reload. Every call is
     guarded — whichever hook the installed UpCart version exposes will fire,
     the rest are no-ops. */
  function refreshDrawer(){
    try { if (window.upcart && typeof window.upcart.refresh === 'function') { window.upcart.refresh(); } } catch (e) {}
    try { if (typeof window.upcartRefreshCart === 'function') { window.upcartRefreshCart(); } } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('upcart:refresh', { bubbles: true })); } catch (e) {}
  }

  function enforce(pass, changed){
    pass = pass || 0; changed = changed || 0;
    if (pass > 8) { enforcing = false; if (changed) { refreshDrawer(); } return; }   // hard stop, never loop
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) { enforcing = false; return; }
        var qty = bundleQty(cart);
        var codeMode = cartInCodeMode(cart);
        /* legacy: tier decides the plan; code mode: one plan above tier 1, the
           tier lives in the discount code */
        var desired = codeMode
          ? (qty >= TIER1 ? PLAN_NEW : null)
          : (qty >= TIER2 ? PLAN_T2 : (qty >= TIER1 ? PLAN_T1 : null));
        var items = cart.items || [];

        for (var i = 0; i < items.length; i++) {
          var it = items[i], p = it.properties || {};
          if (!kopIsBundleLine(p)) { continue; }

          /* gift: only valid while the cart holds a full tier-2 bundle */
          if (p._bundle_gift === 'true') {
            if (qty < TIER2) {
              changeLine(it.key, 0, undefined).then(function(){ enforce(pass + 1, changed + 1); }, function(){ enforcing = false; });
              return;
            }
            continue;
          }
          if (!it.selling_plan_allocation) { continue; }

          var current = it.selling_plan_allocation.selling_plan.id;
          var target = desired;
          if (target === null) {
            /* below the bundle minimum: only touch lines still sitting on a
               bundle plan; leave ordinary subscriptions alone */
            if (!isBundlePlan(current)) { continue; }
            target = basePlanFor(it);   // base S&S plan, or null -> one-time
          }
          if (String(current) === String(target)) { continue; }

          changeLine(it.key, it.quantity, target)
            .then(function(){ enforce(pass + 1, changed + 1); }, function(){ enforcing = false; });
          return;   // one change per pass; keys shift when lines merge
        }
        /* plans are settled; now the code (code mode only, or when a stale
           bundle code is still on a cart that no longer qualifies) */
        if (codeMode || cartHasBundleCode(cart)) {
          reconcileCode(cart, codeMode ? qty : 0).then(function (didChange) {
            enforcing = false;
            sanitizeSelectors();
            if (changed || didChange) { refreshDrawer(); }
          });
          return;
        }
        enforcing = false;
        sanitizeSelectors();
        if (changed) { refreshDrawer(); }
      })
      .catch(function () { enforcing = false; });
  }

  function scheduleEnforce(){
    clearTimeout(enforceTimer);
    enforceTimer = setTimeout(function () {
      if (enforcing) { return; }
      enforcing = true;
      enforce(0, 0);
    }, 350);
  }

  /* ---------- wiring: run on load, cart mutations, drawer re-renders ----------
     The network hooks below only catch calls made through the wrappers we
     install; UpCart binds its own reference to fetch/XHR before custom.js
     loads, so its quantity/plan changes bypass them. The drawer ALWAYS
     re-renders its DOM after a cart change, so the MutationObserver is the
     primary trigger — it schedules an enforcement pass (debounced; a pass
     where nothing mismatches is one cached /cart.js GET and a no-op). */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = _fetch.apply(this, arguments);
    if (/\/cart\/(add|update|clear)/.test(url)) { promise.then(scheduleEnforce, function () {}); }
    if (/\/cart\/change/.test(url) && !enforcing) { promise.then(scheduleEnforce, function () {}); }
    return promise;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && !enforcing) {
      this.addEventListener('load', scheduleEnforce);
    }
    return xo.apply(this, arguments);
  };

  var sanitizeTimer = null;
  var rafBurst = 0;
  function scheduleSanitize(immediate){
    if (immediate) {
      sanitizeSelectors();
      return;
    }
    clearTimeout(sanitizeTimer);
    sanitizeTimer = setTimeout(sanitizeSelectors, 40);
  }
  /* After drawer paints, React often re-commits options for a few frames. */
  function burstSanitize(){
    var n = 0;
    cancelAnimationFrame(rafBurst);
    (function tick(){
      sanitizeSelectors();
      n++;
      if (n < 20) { rafBurst = requestAnimationFrame(tick); }
    })();
  }

  function inDrawerNode(node){
    if (!node || !node.closest) { return false; }
    try { return !!node.closest(DRAWER_SEL); } catch (e) { return false; }
  }

  var mo = new MutationObserver(function (muts) {
    var drawerHit = false;
    var optionHit = false;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (!t) { continue; }
      if (t.tagName === 'SELECT' || t.tagName === 'OPTION' || t.tagName === 'OPTGROUP' ||
          (t.querySelector && t.querySelector('select, option'))) {
        optionHit = true;
      }
      if (inDrawerNode(t) || (t.host && inDrawerNode(t.host))) { drawerHit = true; }
      /* Attach observers to any newly created open shadow roots. */
      var nodes = muts[i].addedNodes;
      if (nodes && nodes.length) {
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n && n.shadowRoot) { observeRoot(n.shadowRoot); drawerHit = true; }
          if (n && n.querySelectorAll) {
            var deep = n.querySelectorAll('*');
            for (var k = 0; k < deep.length; k++) {
              if (deep[k].shadowRoot) { observeRoot(deep[k].shadowRoot); drawerHit = true; }
            }
          }
        }
      }
    }
    if (optionHit || drawerHit) { scheduleSanitize(false); }
    if (drawerHit) {
      burstSanitize();
      if (!enforcing) { scheduleEnforce(); }
    }
  });

  function observeRoot(root){
    if (!root) { return; }
    if (observedRoots) {
      if (observedRoots.has(root)) { return; }
      observedRoots.add(root);
    } else if (root.__rhoPlanObs) { return; }
    else { root.__rhoPlanObs = true; }
    try { mo.observe(root, { childList: true, subtree: true }); } catch (e) {}
    injectCss(root);
  }

  function watchNewShadows(){
    observeRoot(document.documentElement);
    observeRoot(document.body);
    var all = qsaSafe(document, DRAWER_SEL);
    for (var i = 0; i < all.length; i++) {
      observeRoot(all[i]);
      if (all[i].shadowRoot) { observeRoot(all[i].shadowRoot); }
      var deep = qsaSafe(all[i], '*');
      for (var j = 0; j < deep.length; j++) {
        if (deep[j].shadowRoot) { observeRoot(deep[j].shadowRoot); }
      }
    }
    /* Also scan for any open shadow roots under body (UpCart host may not
       include "upcart" in the light-DOM class at first paint). */
    var stars = qsaSafe(document, 'body *');
    for (var s = 0; s < stars.length; s++) {
      if (stars[s].shadowRoot) { observeRoot(stars[s].shadowRoot); }
    }
  }

  /* UpCart's aboveHeader script re-assigns window.upcartOnCartUpdated on
     every cart paint (see UpCartDisableQTY). A normal wrap gets overwritten.
     Trap the properties so OUR strip always runs after their handler. */
  var hookStore = { upcartOnCartUpdated: null, upcartOnCartLoaded: null };
  function installHookTrap(name){
    if (window.__rhoPlanHookTrap && window.__rhoPlanHookTrap[name]) { return; }
    window.__rhoPlanHookTrap = window.__rhoPlanHookTrap || {};
    if (typeof window[name] === 'function' && !window[name].__rhoPlanTrapProxy) {
      hookStore[name] = window[name];
    }
    try {
      Object.defineProperty(window, name, {
        configurable: true,
        enumerable: true,
        get: function () {
          var proxy = function () {
            var fn = hookStore[name];
            if (typeof fn === 'function') {
              try { fn.apply(this, arguments); } catch (e) {}
            }
            try { stripAllUpcartDropdowns(); sanitizeSelectors(); } catch (e2) {}
            if (!enforcing) { scheduleEnforce(); }
          };
          proxy.__rhoPlanTrapProxy = true;
          return proxy;
        },
        set: function (fn) { hookStore[name] = fn; }
      });
      window.__rhoPlanHookTrap[name] = true;
    } catch (e) {}
  }

  /* Direct path used by the trap + open-cart loop. */
  function stripAllUpcartDropdowns(){
    var sels = document.querySelectorAll(
      '#upCart select.upcart-subscription-upgrade-dropdown,' +
      '#UpcartPopup select.upcart-subscription-upgrade-dropdown,' +
      'select.upcart-subscription-upgrade-dropdown,' +
      'select[class*="SubscriptionUpgradesModule"]'
    );
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (selectOnBundlePlan(sel)) { lockSelect(sel); continue; }
      stripBundleOptions(sel);
    }
  }
  /* Expose for UpCart HTML-field scripts (call from UpCartDisableQTY). */
  window.rhoStripUpcartBundlePlans = function () {
    try { stripAllUpcartDropdowns(); sanitizeSelectors(); } catch (e) {}
  };

  document.addEventListener('click', function (e) {
    var path = [];
    try { path = e.composedPath ? e.composedPath() : [e.target]; } catch (err) { path = [e.target]; }
    var hit = false;
    for (var i = 0; i < path.length; i++) {
      if (inDrawerNode(path[i]) || (path[i] && path[i].host && inDrawerNode(path[i].host))) { hit = true; break; }
      if (path[i] && (path[i].id === 'upCart' || path[i].id === 'UpcartPopup')) { hit = true; break; }
    }
    if (hit) {
      stripAllUpcartDropdowns();
      if (!enforcing) { setTimeout(scheduleEnforce, 500); }
      scheduleSanitize(false);
    }
  }, true);
  document.addEventListener('pointerdown', preOpenSanitize, true);
  document.addEventListener('touchstart', preOpenSanitize, true);
  document.addEventListener('mousedown', preOpenSanitize, true);
  document.addEventListener('focus', preOpenSanitize, true);

  /* While the cart is open, re-strip on rAF — React re-inserts options after
     deletes; looping while .upcartPopupShow is present keeps the list clean. */
  var cartLoopOn = false;
  function cartIsOpen(){
    return !!(document.querySelector('#UpcartPopup.upcartPopupShow, .upcartPopupShow, #upCart .upcartPopupShow'));
  }
  function scheduleCartWatch(){
    setTimeout(function watch(){
      if (cartIsOpen()) {
        if (!cartLoopOn) {
          cartLoopOn = true;
          (function loop(){
            if (!cartIsOpen()) { cartLoopOn = false; scheduleCartWatch(); return; }
            stripAllUpcartDropdowns();
            requestAnimationFrame(loop);
          })();
        }
      } else {
        cartLoopOn = false;
        scheduleCartWatch();
      }
    }, 400);
  }

  function boot(){
    installHookTrap('upcartOnCartUpdated');
    installHookTrap('upcartOnCartLoaded');
    watchNewShadows();
    stripAllUpcartDropdowns();
    sanitizeSelectors();
    burstSanitize();
    scheduleEnforce();
    scheduleCartWatch();
    var polls = 0;
    var poll = setInterval(function () {
      watchNewShadows();
      stripAllUpcartDropdowns();
      sanitizeSelectors();
      polls++;
      if (polls > 30) { clearInterval(poll); }
    }, 400);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

/* ============================================================
   Theme cart-drawer watchdog (17 Jul 2026, re-applied)
   While UpCart is installed, the Archetype drawer (#CartDrawer) must never
   stay open: any path that opens it (header cart icon, a stray
   ajaxProduct:added) puts js-drawer-open on <html> (overflow:hidden) plus a
   mobile touch scroll lock that shadow-DOM taps can never dismiss — leaving
   the page unscrollable on iOS. Whenever that class appears while UpCart is
   present, fire the theme's own 'cart:close' so it unwinds its lock cleanly,
   and hard-strip the class if it survives.
   ============================================================ */
(function () {
  function upcartPresent() {
    return typeof window.upcartOpenCart === 'function' ||
           typeof window.upcartRefreshCart === 'function' ||
           !!document.querySelector('[id^="upcart"], [id^="upCart"], upcart-cart');
  }
  var docEl = document.documentElement;
  var healing = false;
  function heal() {
    if (healing) { return; }
    if (!docEl.classList.contains('js-drawer-open')) { return; }
    if (!upcartPresent()) { return; }
    healing = true;
    try { document.dispatchEvent(new CustomEvent('cart:close')); } catch (e) {}
    setTimeout(function () {
      if (docEl.classList.contains('js-drawer-open') && upcartPresent()) {
        docEl.classList.remove('js-drawer-open');
        try {
          if (window.theme && theme.a11y && typeof theme.a11y.unlockMobileScrolling === 'function') {
            theme.a11y.unlockMobileScrolling('#CartDrawer');
          }
        } catch (e) {}
      }
      healing = false;
    }, 250);
  }
  try {
    new MutationObserver(heal).observe(docEl, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', heal); }
  else { heal(); }
})();

/* ============================================================
   Rho LAUNCH code — free blender bottle auto-add [Kopstorm]
   05 Aug 2026, Retention team campaign.
   When the LAUNCH discount is active (customer arrived via
   /discount/LAUNCH, which sets the discount_code cookie) and
   the cart contains at least one subscription line, this adds
   the blender bottle as a one-time line tagged _launch_gift.
   The rho-launch-code Function zeroes that line at checkout
   and gives 30% off every subscription line.
   Rules (Mellina, Aug 5):
   - bottle only with a subscription purchase; if the last
     subscription line is removed, the bottle is removed too
   - never a second bottle: skips when the tier-2 _bundle_gift
     bottle or any other blender bottle line is already there
   Manual code entry at checkout gets the 30% but no bottle
   (nothing can insert cart lines at that stage) — known and
   communicated limitation.
   ============================================================ */
(function () {
  var CODE = 'LAUNCH';
  var BOTTLE_HANDLE = 'blender-bottle'; // matches gift_product in the bundle section settings
  var bottleVid = null;
  var busy = false;
  var timer = null;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function codeActive() {
    var c = getCookie('discount_code');
    return !!c && c.trim().toUpperCase() === CODE;
  }
  function resolveVid(cb) {
    if (bottleVid) { cb(); return; }
    fetch('/products/' + BOTTLE_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) { return; }
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        bottleVid = (v || p.variants[0]).id;
        cb();
      })
      .catch(function () {});
  }
  function sync() {
    if (busy || !codeActive()) { return; }
    resolveVid(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) { return; }
          var subQty = 0, launchLine = null, tierGift = false, otherBottle = false;
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {};
            if (p._launch_gift === 'true') { launchLine = it; return; }
            if (p._bundle_gift === 'true') { tierGift = true; return; }
            if (it.selling_plan_allocation) { subQty += it.quantity; }
            if (it.variant_id === bottleVid) { otherBottle = true; }
          });
          var shouldHave = subQty > 0 && !tierGift && !otherBottle;
          if (shouldHave && !launchLine) {
            busy = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: bottleVid, quantity: 1, properties: { _launch_gift: 'true' } }]
              })
            }).then(function () { busy = false; refreshDrawer(); })
              .catch(function () { busy = false; });
          } else if (launchLine && (!shouldHave || launchLine.quantity > 1)) {
            busy = true;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: launchLine.key, quantity: shouldHave ? 1 : 0 })
            }).then(function () { busy = false; refreshDrawer(); })
              .catch(function () { busy = false; });
          }
        })
        .catch(function () {});
    });
  }
  function refreshDrawer() {
    try { if (typeof window.upcartRefreshCart === 'function') { window.upcartRefreshCart(); } } catch (e) {}
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  /* Re-sync after any cart mutation (skips our own while busy). */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) { p.then(schedule, function () {}); }
    return p;
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); }
  else { sync(); }
})();
